import { render, staticRenderFns } from "./ApplicantAddress.vue?vue&type=template&id=f2341464&"
import script from "./ApplicantAddress.vue?vue&type=script&lang=js&"
export * from "./ApplicantAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports